<template>
  <div v-if="dimension" class="step__body">
    <h3>{{ step.title || step.name }}</h3>
    <p>{{ step.description }}</p>
    <div class="row option">
      <DimensionOption :option="widthOption" :option-dim="dimension.width" type="width"/>
      <DimensionOption :option="heightOption" :option-dim="dimension.height" :values="heightValues" type="height"/>
    </div>
  </div>
</template>
<script setup>
import DimensionOption from '@/pages/system/steps/option/dimensionOption.vue'
import { computed } from '@vue/reactivity'
import { watch } from '@vue/runtime-core'
import { useStore } from 'vuex'
import { nearestAllowedValue, sharedGateHeightValues } from '~/lib/dimensionLimits'

const store = useStore()

const step = computed(() => {
  return store.getters['system/currentStep']
})
const dimension = computed(() => {
  return store.getters['system/dimension']
})

function dimensionCard (type) {
  const media = dimension.value?.[type] || {}
  const text = media.tooltip?.text || ''
  const tooltipImage = media.tooltip?.image || null
  const tooltip = (text || tooltipImage)
    ? { text, image: tooltipImage }
    : null
  return {
    title: media.title || '',
    description: '',
    image: media.image || null,
    tooltip
  }
}

const widthOption = computed(() => dimensionCard('width'))
const heightOption = computed(() => dimensionCard('height'))

const heightValues = computed(() => {
  const system = store.getters['system/system']
  if (!system) {
    return []
  }
  const gates = ['main', 'sub_1', 'sub_2']
    .filter(field => system['config_' + field]?.show && system[field])
    .map(field => system[field])
  return sharedGateHeightValues(gates)
})

watch([heightValues, dimension], ([values, dim]) => {
  if (!dim?.height || !values?.length) {
    return
  }
  const next = nearestAllowedValue(values, dim.height.value)
  if (next !== Number.parseInt(dim.height.value, 10)) {
    store.dispatch('system/setDimensionBase', {
      type: 'height',
      value: next
    })
  }
})
</script>
